import {
  action,
  computed,
  IReactionDisposer,
  makeObservable,
  observable,
  reaction,
} from 'mobx';

import {
  CellControllerKind,
  SelectControllerEntity,
} from 'entities/TableControllers';

import { ITableControllerBase, TableControllerParams } from '../interface';

type PrivateFields = '_value';

export default class TableSelectController
  implements ITableControllerBase<string>
{
  constructor({
    record,
    onSave,
  }: TableControllerParams<SelectControllerEntity>) {
    this._value = record.controller;
    this._initialValue = record.controller;

    this._reactions.push(reaction(() => this._value, onSave));
    makeObservable<TableSelectController, PrivateFields>(this, {
      _value: observable.ref,
      controllerValue: computed,
      setValue: action.bound,

      toServerFormat: computed,

      reset: action.bound,
    });
  }

  private _value: SelectControllerEntity['controller'];
  private readonly _reactions: IReactionDisposer[] = [];

  private readonly _initialValue: SelectControllerEntity['controller'];

  readonly isUpdateBlocked = false;

  get controllerValue() {
    return this._value;
  }

  get controllerKind() {
    return CellControllerKind.SELECT;
  }

  get toServerFormat() {
    return this._value.value?.value || '';
  }

  reset(): void {
    this._value = this._initialValue;
  }

  destroy() {
    this._reactions.forEach((reaction) => reaction());
  }

  setValue(nextValue: string): void {
    const option = this._value.options.find(
      (value) => value.value === nextValue
    );

    if (!option || this._value.value === option) {
      return;
    }

    this._value = {
      options: this._initialValue.options,
      value: option,
    };
  }
}
